import React from 'react';
import { useSelector } from 'react-redux';

import { mapServiceSelector, gensetTrackReportIdSelector } from '../../features/map/mapSlice';
import GoogleGensetTrackLine from './google/GoogleGensetTrackLine';
import OsmGensetTrackLine from './osm/OsmGensetTrackLine';

const GensetTrackOverlay = () => {
    const mapService = useSelector(mapServiceSelector);
    const reportId = useSelector(gensetTrackReportIdSelector);

    if (!reportId) return null;

    return mapService === 'google'
        ? <GoogleGensetTrackLine />
        : <OsmGensetTrackLine />;
};

export default GensetTrackOverlay;
